import { wrapperBuilder } from './build';
const variables = wrapperBuilder.getVariablesRegisterInstance();

variables.addVariable('styles', { startValue: {} });
